/**
 * Common technology keywords, tools, certifications, and terms
 * Used for autosuggest in Intel Search
 */

// Certifications
export const CERTIFICATIONS = [
  // AWS Certifications
  'AWS Certified Solutions Architect',
  'AWS Certified Solutions Architect - Associate',
  'AWS Certified Solutions Architect - Professional',
  'AWS Certified Developer',
  'AWS Certified Developer - Associate',
  'AWS Certified SysOps Administrator',
  'AWS Certified DevOps Engineer',
  'AWS Certified DevOps Engineer - Professional',
  'AWS Certified Security - Specialty',
  'AWS Certified Advanced Networking',
  'AWS Certified Data Analytics',
  'AWS Certified Machine Learning',
  'AWS Certified Database - Specialty',
  'AWS Certified Cloud Practitioner',

  // Azure Certifications
  'Azure Administrator',
  'Azure Administrator Associate',
  'Azure Developer',
  'Azure Developer Associate',
  'Azure Solutions Architect Expert',
  'Azure DevOps Engineer Expert',
  'Azure Security Engineer Associate',
  'Azure Data Engineer Associate',
  'Azure Data Scientist Associate',
  'Azure AI Engineer Associate',
  'Azure Fundamentals',
  'Microsoft Certified Azure Administrator',
  'Microsoft Certified Azure Developer',

  // Google Cloud Certifications
  'Google Cloud Professional',
  'Google Cloud Professional Cloud Architect',
  'Google Cloud Professional Data Engineer',
  'Google Cloud Professional Cloud Developer',
  'Google Cloud Professional DevOps Engineer',
  'Google Cloud Professional Cloud Security Engineer',
  'Google Cloud Associate Cloud Engineer',
  'Google Cloud Professional Machine Learning Engineer',
  'GCP Professional Cloud Architect',
  'GCP Associate Cloud Engineer',

  // Kubernetes & Container Certifications
  'Certified Kubernetes Administrator',
  'CKA',
  'CKAD',
  'Certified Kubernetes Application Developer',
  'Certified Kubernetes Security Specialist',
  'CKS',
  'Docker Certified Associate',
  'Red Hat Certified Specialist in Containers',

  // Agile & Project Management
  'Certified ScrumMaster',
  'CSM',
  'Professional Scrum Master',
  'PSM',
  'PSM I',
  'PSM II',
  'PSM III',
  'Certified Scrum Product Owner',
  'CSPO',
  'Professional Scrum Product Owner',
  'PSPO',
  'SAFe Agilist',
  'SAFe',
  'SAFe Scrum Master',
  'SAFe Product Owner',
  'PMP',
  'Project Management Professional',
  'PRINCE2',
  'PRINCE2 Foundation',
  'PRINCE2 Practitioner',
  'PMI-ACP',
  'Agile Certified Practitioner',
  'CAPM',
  'Certified Associate in Project Management',

  // Security Certifications
  'CISSP',
  'Certified Information Systems Security Professional',
  'CISM',
  'Certified Information Security Manager',
  'CISA',
  'Certified Information Systems Auditor',
  'CEH',
  'Certified Ethical Hacker',
  'OSCP',
  'Offensive Security Certified Professional',
  'Security+',
  'CompTIA Security+',
  'GIAC Security Essentials',
  'GSEC',
  'CompTIA CySA+',
  'Certified Cloud Security Professional',
  'CCSP',

  // Networking Certifications
  'CCNA',
  'Cisco Certified Network Associate',
  'CCNP',
  'Cisco Certified Network Professional',
  'CCIE',
  'Cisco Certified Internetwork Expert',
  'CompTIA Network+',
  'Network+',
  'CompTIA A+',
  'A+',
  'Juniper Networks Certified Associate',
  'JNCIA',

  // Programming & Development
  'Oracle Certified Professional',
  'OCP',
  'Oracle Certified Java Programmer',
  'OCPJP',
  'Oracle Certified Associate',
  'OCA',
  'Microsoft Certified Professional',
  'MCP',
  'Microsoft Technology Associate',
  'MTA',
  'Red Hat Certified Engineer',
  'RHCE',
  'Red Hat Certified System Administrator',
  'RHCSA',
  'Linux Professional Institute Certification',
  'LPIC',
  'Linux Foundation Certified System Administrator',
  'LFCS',
  'Zend Certified PHP Engineer',

  // Database Certifications
  'Oracle Database Administrator Certified Professional',
  'Oracle DBA',
  'Microsoft Certified Database Administrator',
  'MySQL Database Administrator',
  'MongoDB Certified Developer',
  'MongoDB Certified DBA',
  'PostgreSQL Certified Professional',

  // Cloud & Platform Specific
  'Salesforce Certified',
  'Salesforce Administrator',
  'Salesforce Advanced Administrator',
  'Salesforce Platform Developer I',
  'Salesforce Platform Developer II',
  'Salesforce Certified Technical Architect',
  'ServiceNow Certified System Administrator',
  'ServiceNow Certified Application Developer',
  'VMware Certified Professional',
  'VCP',
  'Citrix Certified Associate',
  'CCA',

  // DevOps & Automation
  'Terraform Associate',
  'HashiCorp Certified Terraform Associate',
  'Ansible Automation',
  'Red Hat Certified Specialist in Ansible Automation',
  'Jenkins Engineer Certification',
  'GitLab Certified Associate',

  // Data & Analytics
  'Cloudera Certified Professional',
  'CCP',
  'Databricks Certified Data Engineer',
  'Databricks Certified Machine Learning Professional',
  'Snowflake SnowPro Core Certification',
  'Informatica PowerCenter Certification',
  'Tableau Desktop Specialist',
  'Tableau Certified Data Analyst',
  'Microsoft Certified Power BI Data Analyst',

  // AI & Machine Learning
  'TensorFlow Developer Certificate',
  'Google Professional Machine Learning Engineer',
  'IBM Data Science Professional Certificate',
  'Deep Learning Specialization',

  // ITIL & Service Management
  'ITIL Foundation',
  'ITIL',
  'ITIL 4 Foundation',
  'ITIL Expert',
  'ITIL Master',
  'Certified ISO/IEC 20000',

  // Quality & Testing
  'ISTQB Foundation',
  'ISTQB',
  'ISTQB Certified Tester',
  'Certified Software Tester',
  'CSTE',
];

export const ROLES = [
  'Software Engineer',
  'Full Stack Developer',
  'Frontend Developer',
  'Backend Developer',
  'DevOps Engineer',
  'Data Engineer',
  'Data Scientist',
  'Machine Learning Engineer',
  'QA Engineer',
  'Test Automation',
  'System Administrator',
  'Security Engineer',
  'Product Manager',
  'Engineering Manager',
  'Tech Lead',
  'Architect',
  'Solutions Architect',
];

// Combine all keywords
export const ALL_COMMON_KEYWORDS = [...CERTIFICATIONS, ...ROLES].sort();
